<template>
   <div :class="`tab-menu ${open?'tab-open':'tab-closed'}`"> 
       <div @click="change">
        <b-icon class="my-icon interactive" icon="sort-down" >
        </b-icon>
       </div>
        <!-- <hr> -->
        <div class="scrollable">
            <slot ></slot>
        </div>
   </div>
</template>

<script>
export default {
    name:"DownMenu",
    data(){
        return{
            open:false
        }
    },
    methods:{
        change(){
            this.open = !this.open
            this.$emit("change",this.open)
        }
    }

}
</script>

<style lang="scss">

.tab-menu{
  border-radius: 20px 20px 0 0;
  position: fixed;
  left:0;
  right:0;
  width: 100%;
  max-width: 600px;
  margin-left: auto; 
  margin-right: auto; 
  display: inline-block;
  text-align: center;
  background-color: #F5F5F5;
  transition: height 0.5s ease-in-out, 
              top 0.5s ease-in-out;
  box-shadow: rgb(0 0 0 / 20%) 0px -2px 10px
  
}
hr{
    background-color: #C7C7C7;
    margin:0;
}
.tab-closed{
  top: calc(100vh - 38px);
  height: 38px;
  .my-icon{
    transform: rotate(180deg);    
  }
}
.tab-open{
    top: calc(100vh - 50vh);
    height: 50%;
}
.my-icon{
    margin: 7px 0;
    color:#D1D1D1 !important;
    transition: transform 0.3s;
}
.scrollable{
    overflow-y: scroll;
    height: calc(100% - 38px);
}
</style>